import {Kelly} from './Kelly';
import BranchDesktopBase from '../BranchDesktopBase';

export class BranchDesktopKelly extends Kelly {
    constructor() {
        super();
        this.setKellyBranchDesktopColors();
    }

    private setKellyBranchDesktopColors() {
        this.colors.general.primaryColor = '#2175d9';
        this.colors.general.secondaryColor = '#999';
        this.colors.general.tertiaryColor = '#2175d9';
        this.colors.background.blueBackgroundColor = '#2175d9';
    }
}

const branchDesktopKellyTheme = BranchDesktopBase.setShareStyles(new BranchDesktopKelly());
export default branchDesktopKellyTheme;



// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/themes/Kelly/branch-desktop.ts